import { Form, FormInstance } from 'antd'
import { Component, createRef } from 'react'
import { StwItemType } from '../../../../api'
import ItemTypes from '../../../../api/ItemTypes'
import { AdvancedForm, StylewherePage, Section, DefaultHeader } from '../../../../components'
import { ITEM_TYPE_FIELDS as ItemsTypeFields } from '../../../../config/Pages/Settings/ItemTypes'
import { AttributeUtil } from '../../../../config/utility/utility'
import { FormUtility } from '../../../../config/utility/formUtility'
import { FormValidateMessages, IdentifierTypes } from '../../../../constants'
import { __, T } from '../../../../shared/i18n'
import { navigate } from '../../../../shared/router'
import { ExtendRouteComponentProps } from '../../../../types'
import { getFragmentObject, getBackURL } from '../../../../shared/utils'

interface State {
  itemType: StwItemType
  loader: boolean
  isCodeEditableByDescription: boolean
}

class ItemTypeForm extends Component<ExtendRouteComponentProps, State> {
  formRef = createRef<FormInstance>()

  constructor(props) {
    super(props)
    this.state = {
      itemType: {},
      loader: true,
      isCodeEditableByDescription: true,
    }
  }

  componentDidMount() {
    this.initialize()
  }

  initialize = async () => {
    const { match } = this.props
    let result
    if (match) {
      const itemTypeId = match.params.itemTypeId
      if (itemTypeId !== '' && itemTypeId !== 'create') {
        result = await ItemTypes.get(itemTypeId)
      }
    }
    this.setState(
      {
        itemType: result || {},
        isCodeEditableByDescription: !result,
        loader: false,
      },
      this.updateFormFieldsValue
    )
  }

  updateFormFieldsValue = () => {
    if (this.formRef && this.formRef.current) {
      this.formRef.current.setFieldsValue(this.state.itemType)
    }
  }

  handleChange = async (key, value) => {
    const { itemType, isCodeEditableByDescription } = this.state
    let editable = isCodeEditableByDescription
    AttributeUtil.setAttribute(itemType, key, value)
    if (key === 'description' && isCodeEditableByDescription) {
      FormUtility.handleDescription(value, itemType, this.formRef)
    } else if (key === 'code') {
      editable = false
    }
    this.setState({
      itemType: itemType,
      isCodeEditableByDescription: editable,
    })
  }

  store = () => {
    const { itemType } = this.state
    const { queryString } = this.props
    if (itemType.id) {
      ItemTypes.update<StwItemType>(itemType).then(() => {
        navigate(`/configuration/settings/itemTypes${queryString ?? ''}`)
      })
    } else {
      ItemTypes.insert<StwItemType>(itemType).then((z) => {
        if (z && z.id) {
          navigate(`/configuration/settings/itemTypes${queryString ?? ''}`)
        }
      })
    }
  }

  render() {
    const { itemType, loader } = this.state
    const { breadcrumbs, queryString } = this.props
    const title = itemType.id ? __(T.itemtype.edit) : __(T.itemtype.create_new)
    const fragment = !loader ? getFragmentObject(itemType, 'id', __(T.itemtype.create_new)) : undefined
    return (
      <Form
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        layout="vertical"
        onFinish={this.store}
        style={{ width: '100%', height: '100%' }}
        ref={this.formRef}
        initialValues={itemType}
        validateMessages={FormValidateMessages}
        scrollToFirstError
      >
        <StylewherePage {...this.props} noOverflow fragment={fragment}>
          <DefaultHeader
            backPath={getBackURL(queryString, breadcrumbs)}
            title={loader ? '...' : title}
            skeleton={{ active: loader }}
            actions={[
              {
                label: __(T.misc.cancel),
                type: 'cancel',
                onClick: () => navigate(`/configuration/settings/itemTypes${queryString ?? ''}`),
              },
              {
                label: itemType.id ? __(T.misc.update) : __(T.misc.create),
                type: 'submit',
              },
            ]}
          />
          <Section customClass="stw-section-page paged-header scroll">
            <AdvancedForm
              record={itemType}
              handleChange={this.handleChange}
              parameters={{ attributeKeys: IdentifierTypes }}
              fields={ItemsTypeFields}
              editing={itemType.id !== undefined}
            />
          </Section>
        </StylewherePage>
      </Form>
    )
  }
}

export default ItemTypeForm
